<!-- layout.component.html -->
<div class="flex flex-col h-screen">
  <app-header [title1]="title1" [title2]="title2"></app-header>

  @if(!isPublicRoute){
  <div class="flex flex-grow overflow-hidden bg-background dark:bg-dark-background">
    <app-sidebar *ngIf="!hideSideBar" [isSlimMode]="isSlimMode"></app-sidebar>
    <div *ngIf="!hideSubSideBar">
      <ng-content select="[side-area]"></ng-content>
    </div>

    <div
      class="flex-grow overflow-hidden print:overflow-visible bg-background dark:bg-dark-background h-full min-h-0 flex flex-col"
      [ngClass]="{
        'border-background-alt dark:border-gray-800 border-l': !hideSubSideBar
      }"
    >
      <ng-content select="[body-area]"></ng-content>
    </div>
  </div>
  } @else {
  <div class="flex w-full flex-grow overflow-auto bg-background dark:bg-dark-background">
    <router-outlet></router-outlet>
  </div>
  }

  <app-footer class="print:hidden"></app-footer>
</div>

<span
  *ngIf="isPublicRoute && isKioskMode"
  class="pointer-events-none fixed bottom-5 left-5 z-40 flex h-8 w-8 items-center justify-center rounded-full bg-amber-50 text-amber-700 shadow-sm ring-1 ring-amber-100"
  aria-label="Kiosk mode"
  title="Kiosk mode"
>
  <lucide-icon name="monitor" class="h-4 w-4"></lucide-icon>
</span>